import Vue from 'vue'
import App from './App'
import router from './router'
import common from '../static/js/common.js'
import 'semantic/dist/semantic.min.js'
import 'semantic/dist/semantic.min.css'
import VueResource from 'vue-resource'
import axios from 'axios'

Vue.prototype.common = common
Vue.use(VueResource)
Vue.config.productionTip = false

axios.defaults.baseURL = process.env.axios.baseURL
axios.defaults.withCredentials = process.env.axios.withCredentials

String.prototype.startsWith || (String.prototype.startsWith = function(t, r) {
    return r = r || 0,
    this.substr(r, t.length) === t
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js